export default __webpack_public_path__ + "static/media/linkedinIconL.4eb7c866.svg";